import { useRef, useEffect, useState } from 'react';

const UseIntersect = (fn = () => {}, threshold = 0.4) => {
  const [element, setElement] = useState([]);
  const watcher = useRef(null);
  const [intersectId, setIntersectId] = useState('');
  const setIntersectElements = (el, id = 'id') => {
    setElement(el);
    setIntersectId(id);
  };

  useEffect(() => {
    if (watcher.current) watcher.current.disconnect();

    watcher.current = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            fn(entry);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold,
      }
    );

    element.forEach(ele => {
      watcher.current.observe(ele);
    });

    return () => {
      watcher.current.disconnect();
    };
  }, [element, intersectId, threshold]);

  return { setElement, setIntersectElements };
};

export default UseIntersect;
